import { createApp } from 'vue';
import UserProfileDropdown from '@/website/UserProfileDropdown.vue';
import { createPinia } from 'pinia';
import { Animations } from '@/../js/website/modules/animations.js';
import { createI18n } from 'vue-i18n/dist/vue-i18n.cjs';

function loadLocaleMessages() {
  return { nl: window.viploge.lng };
}

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  warnHtmlInMessage: 'off',
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: loadLocaleMessages(),
});

// User profile dropdown for website navigation
const userProfileEl = document.getElementById('userProfile');
if (userProfileEl) {
  const profileApp = createApp(UserProfileDropdown, {
    user: window.viploge.user || null,
    size: 'large',
  });
  profileApp.use(createPinia()).use(i18n).mount(userProfileEl);
}

// User profile dropdown for platform home (desktop)
const userProfileDropdownEl = document.getElementById('userProfileDropdown');
if (userProfileDropdownEl) {
  const dropdownApp = createApp(UserProfileDropdown, {
    user: window.viploge.user || null,
    size: 'large',
  });
  dropdownApp.use(createPinia()).use(i18n).mount(userProfileDropdownEl);
}

// User profile dropdown for platform home (mobile)
const userProfileDropdownMobileEl = document.getElementById(
  'userProfileDropdownMobile'
);
if (userProfileDropdownMobileEl) {
  const dropdownMobileApp = createApp(UserProfileDropdown, {
    user: window.viploge.user || null,
    size: 'small',
  });
  dropdownMobileApp
    .use(createPinia())
    .use(i18n)
    .mount(userProfileDropdownMobileEl);
}

// Scroll-animaties van de blokken: die zetten .animate-on-scroll op opacity 0 en
// rekenen erop dat deze module .animated toevoegt. De module zat alleen in de
// blokkenbibliotheek, waardoor teksten in onder meer het slotblok onzichtbaar bleven.
new Animations();

// Captcha van het contactformulier: alleen laden op de contactpagina.
const contactFormEl = document.querySelector('form[data-contact-form]');
if (contactFormEl) {
  import('@/../js/website/modules/contact-captcha.js').then(function ({
    initContactCaptcha,
  }) {
    initContactCaptcha(contactFormEl);
  });
}
